import getIn from 'transmute/getIn';
import { createSelector } from 'reselect';
import { getCurrentObjectTypeId } from '../../init/selectors/routerStateSelectors';
import { NOT_SPECIFIED } from 'customer-data-objects/property/AccessLevel';
const getFieldLevelPermissionsSlice = state => state.fieldLevelPermissions;
const emptyObject = {};
export const getPermissionsForCurrentObjectType = createSelector([getFieldLevelPermissionsSlice, getCurrentObjectTypeId], (slice, objectTypeId) => slice[objectTypeId] || emptyObject);
export const getGetPropertyPermission = createSelector([getPermissionsForCurrentObjectType], permissions => propertyName => getIn([propertyName, 'accessLevel'], permissions) || NOT_SPECIFIED);